import { BgColorsOutlined, CheckCircleFilled } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'
import { FC, useState } from 'react'
import { hasActiveForms } from '../../../../../../helpers/entities/shipment/has-active-forms'
import { userStorage } from '../../../../../../services/user-storage'
import PrintQueueEntry from '../../../../../../types/api/print-queue-entry'
import { isCurrentUserActiveExecutor } from '../../helpers/print-job-helpers'
import PaintsModal from './paints-modal'

interface PaintsButtonProps {
    printQueueEntry: PrintQueueEntry
}

const PaintsButton: FC<PaintsButtonProps> = ({ printQueueEntry }) => {
    const [open, setOpen] = useState(false)
    const printJob = printQueueEntry.print_job

    if (!printJob || !hasActiveForms(printJob.shipment)) return null

    const confirmed = Boolean(printJob.paintsConfirmedAt)
    const disabled = !isCurrentUserActiveExecutor(printJob, userStorage.get()?.documentId)

    return (
        <>
            <Tooltip title={confirmed ? 'Краски подтверждены' : 'Краски не подтверждены'}>
                <Button
                    icon={confirmed ? <CheckCircleFilled /> : <BgColorsOutlined />}
                    disabled={disabled}
                    onClick={() => setOpen(true)}
                >
                    Краски
                </Button>
            </Tooltip>
            {open && (
                <PaintsModal
                    printJobDocumentId={printJob.documentId}
                    onClose={() => setOpen(false)}
                />
            )}
        </>
    )
}

export default PaintsButton
